import React from 'react';
import PropTypes from 'prop-types';
import Raven from 'raven-js';

import SaveFileButton from 'admin-moderator/components/SaveFileButton';
import MaterialNotFound from 'components/MaterialNotFound';
import ButtonLoader from 'components/Loader/ButtonLoader';
import CenteredContainer from 'styled/Page/CenteredContainer';

import BlurImage from './BlurImage';
import ImageContainer from './ImageContainer';
import StyledImage from './StyledImage';
import VideoContainer from './VideoContainer';
import NotFoundWrapper from './NotFoundWrapper';

// TODO: разделить на видео и изображение
export class MediaFile extends React.PureComponent {
  state = {
    hasImage: false,
    imageLoading: true,
  };

  componentDidMount() {
    if (this.props.mediaType === 'image') {
      this.checkImageExist();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.mediaType === 'image' && prevProps.cover !== this.props.cover) {
      this.checkImageExist();
    }
  }

  componentWillUnmount() {
    if (this.image) {
      this.image.removeEventListener('load', this.handleImageLoad);
      this.image.removeEventListener('error', this.handleImageError);
    }
  }

  get videoErrorText() {
    if (this.props.videoStatus === 'waiting') return 'Видео ожидает конвертации';
    if (this.props.videoStatus === 'converting') return 'Идет процесс конвертации видео';
    if (this.props.videoStatus === 'failed') return 'Не удалось сконвертировать видео';

    return 'Видео недоступно или отсутствует';
  }

  handleImageLoad = () => {
    this.setState({ hasImage: true, imageLoading: false });
  }

  handleImageError = () => {
    Raven.captureException('MediaFile cover loading error', { extra: this.image });
    this.setState({ hasImage: false, imageLoading: false });
  }

  checkImageExist() {
    if (this.props.mediaType === 'image' && !this.props.url) return;
    if (this.props.mediaType === 'video' && !this.props.cover) return;

    this.image = new Image();
    this.image.addEventListener('load', this.handleImageLoad);
    this.image.addEventListener('error', this.handleImageError);
    this.image.src = this.props.mediaType === 'video' ? this.props.cover : this.props.url;
  }

  render() {
    return (
      <React.Fragment>
        {this.props.loading && (
          <NotFoundWrapper>
            <CenteredContainer><ButtonLoader /></CenteredContainer>
          </NotFoundWrapper>
        )}

        {!this.props.loading && this.props.mediaType === 'video' && (
          <React.Fragment>
            {this.props.url && this.props.videoStatus === 'finished' ? (
              <VideoContainer>
                <SaveFileButton url={this.props.originalUrl} title={this.props.title} />

                <video // eslint-disable-line jsx-a11y/media-has-caption
                  controls
                  height="100%"
                  width="100%"
                  style={{ maxHeight: '446px' }}
                  poster={this.props.cover}
                >
                  <source src={this.props.url} type="video/mp4" />

                  Ваш браузер не поддерживает HTML5 видео.
                </video>
              </VideoContainer>
            ) : (
              <NotFoundWrapper>
                <SaveFileButton url={this.props.originalUrl} title={this.props.title} />

                <MaterialNotFound text={this.videoErrorText} />
              </NotFoundWrapper>
            )}
          </React.Fragment>
        )}

        {!this.props.loading && this.props.mediaType === 'image' && (
          <React.Fragment>
            {this.state.hasImage && (
              <ImageContainer>
                <SaveFileButton url={this.props.url} title={this.props.title} />

                <BlurImage style={{ backgroundImage: `url(${this.props.url})` }} />

                <StyledImage width="800" height="446" src={this.props.url} alt={this.props.title} />
              </ImageContainer>
            )}

            {!this.state.hasImage && (
              <NotFoundWrapper>
                {this.state.imageLoading
                  ? (
                    <CenteredContainer>
                      <ButtonLoader />
                    </CenteredContainer>
                  ) : <MaterialNotFound text="Изображение недоступно или отсутствует" />
                }
              </NotFoundWrapper>
            )}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

MediaFile.propTypes = {
  mediaType: PropTypes.oneOf(['image', 'video']),
  cover: PropTypes.string,
  originalUrl: PropTypes.string,
  url: PropTypes.string,
  title: PropTypes.string,
  loading: PropTypes.bool,
  videoStatus: PropTypes.oneOf(['waiting', 'converting', 'finished', 'failed']),
};

MediaFile.defaultProps = {
  mediaType: 'image',
  cover: '',
  originalUrl: '',
  url: '',
  title: '',
  loading: false,
  videoStatus: undefined,
};

export default MediaFile;
